import cn from 'classnames'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import { CheckIcon, PlusIcon } from '../../../../components/icon'

import styles from './how-it-works.module.scss'

import step1 from './step-1.png'
import step2 from './step-2.png'
import step3 from './step-3.png'
import step4 from './step-4.png'
import step5 from './step-5.png'
import step6 from './step-6.png'
import { commonKeyValues } from '../../../../lib/utils'

const steps = [
  {
    image: step1,
    text: (
      <FormattedMessage
        defaultMessage="Skapa professionella fakturor i din dator, surfplatta eller mobil."
        id="free.how-it-works.text-1"
      />
    ),
    withShadow: true,
  },
  {
    image: step2,
    text: (
      <FormattedMessage
        defaultMessage="Skicka fakturan som en webbfaktura som öppnas i en webbläsare eller maila en PDF."
        id="free.how-it-works.text-2"
      />
    ),
    withShadow: true,
  },
  {
    image: step3,
    text: (
      <FormattedMessage
        defaultMessage="Det finns en mängd olika sätt för mottagaren att betala din faktura. Supersmidigt."
        id="free.how-it-works.text-3"
      />
    ),
    withShadow: true,
  },
  {
    image: step4,
    text: (
      <FormattedMessage
        defaultMessage="Automatisk avprickning på fordran och pengar på ditt konto."
        id="free.how-it-works.text-4"
      />
    ),
    withShadow: true,
  },
  {
    image: step5,
    text: (
      <FormattedMessage
        defaultMessage="Följ upp obetalda fakturor automatiskt med nytt betaldatum och påminnelseavgift."
        id="free.how-it-works.text-5"
      />
    ),
    withShadow: true,
  },
  {
    image: step6,
    text: (
      <FormattedMessage
        defaultMessage="Försäljningsöversikt: Fakturor du skickar registreras som underlag för statistik och rapporter."
        id="free.how-it-works.text-6"
      />
    ),
    withShadow: true,
  },
]

export default function HowItWorks() {
  const timer = React.useRef<number | null>(null)
  const [step, setStep] = React.useState(0)
  const [isTouched, setIsTouched] = React.useState(false)

  React.useEffect(() => {
    const goToNextStep = () => {
      const nextStep = step + 1 >= steps.length ? 0 : step + 1
      setStep(nextStep)
    }

    if (!isTouched) {
      timer.current = window.setTimeout(() => {
        goToNextStep()
      }, 5000)
    } else if (timer.current) {
      window.clearTimeout(timer.current)
    }

    return () => {
      if (timer.current) {
        window.clearTimeout(timer.current)
      }
    }
  }, [step, isTouched])

  return (
    <div className={styles.root}>
      <h2>
        <FormattedMessage defaultMessage="Så här gör du" id="free.how-it-works.heading" />
      </h2>
      <p className={styles.lede}>
        <FormattedMessage
          defaultMessage="Du är igång med smartare och snabbare fakturering på nolltid med några enkla steg."
          id="free.how-it-works.lede"
        />
      </p>

      <div className={styles.mediaContainer}>
        <div className={styles.mediaText}>
          {steps.map((stepMeta, i) => (
            <span
              className={cn(styles.text, step >= i && styles.active)}
              key={stepMeta.image}
              onClick={() => {
                setStep(i)
                setIsTouched(true)
              }}
              onKeyDown={(e) => {
                if (e.keyCode === commonKeyValues.enter) {
                  setStep(i)
                  setIsTouched(true)
                }
              }}
              role="button"
              tabIndex={0}
            >
              {step >= i ? <CheckIcon active className={styles.textIcon} /> : <PlusIcon className={styles.textIcon} />}
              {stepMeta.text}
              {steps.length === i + 1 && <span className={styles.textLast} />}
            </span>
          ))}
        </div>

        <div className={cn(styles.mediaContent, steps[step].withShadow && styles.withShadow)}>
          {steps.map((stepMeta, i) => (
            <img
              alt="Dooer explaing"
              className={cn(styles.image, step === i && styles.active)}
              key={stepMeta.image}
              src={stepMeta.image}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
